import { render, staticRenderFns } from "./OnboardingCreatorReinstatement.vue?vue&type=template&id=3dce5266&scoped=true&"
import script from "./OnboardingCreatorReinstatement.vue?vue&type=script&lang=js&"
export * from "./OnboardingCreatorReinstatement.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingCreatorReinstatement.vue?vue&type=style&index=0&id=3dce5266&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dce5266",
  null
  
)

export default component.exports